"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerEventActionTypesArray = exports.wirePlayerEventCreators = exports.PlayerEventTypeByActionType = exports.playerFinishMatchEvent = exports.playerDeathEvent = exports.clientFinishMatchEvent = exports.afterRerollCardsEvent = exports.afterSellPieceEvent = void 0;
const api_1 = require("@cc-plugins/api");
const quickChat_1 = require("./quickChat");
exports.afterSellPieceEvent = (0, api_1.networkedAction)("afterSellPieceEvent");
exports.afterRerollCardsEvent = (0, api_1.networkedAction)("afterRerollCardsEvent");
exports.clientFinishMatchEvent = (0, api_1.networkedAction)("clientFinishMatchEvent");
exports.playerDeathEvent = (0, api_1.networkedAction)("playerDeathEvent");
exports.playerFinishMatchEvent = (0, api_1.networkedAction)("playerFinishMatchEvent");
const playerEventActionCreators = {
    afterSellPiece: exports.afterSellPieceEvent,
    afterRerollCards: exports.afterRerollCardsEvent,
    clientFinishMatch: exports.clientFinishMatchEvent,
    playerDeath: exports.playerDeathEvent,
    playerFinishMatch: exports.playerFinishMatchEvent,
    playerReceiveQuickChat: quickChat_1.playerReceiveQuickChatEvent,
};
exports.PlayerEventTypeByActionType = Object.fromEntries(Object.keys(playerEventActionCreators).map((key) => [playerEventActionCreators[key].type, key]));
exports.wirePlayerEventCreators = [
    exports.playerDeathEvent,
    quickChat_1.playerReceiveQuickChatEvent,
];
exports.PlayerEventActionTypesArray = exports.wirePlayerEventCreators.map((c) => c.type);
